import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

export const serviceToFirestore = (formValues, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const cleanName = formValues.nameService?.trim() || "Novo Serviço";

    const payload = {
        // Campos Core
        nameService: cleanName,
        searchName: SearchHelper.normalize(cleanName),
        type: formValues.type,
        value: Number(formValues.value),
        allowEntries: formValues.allowEntries,
        experimentalClass: formValues.experimentalClass,
        maxAmountInstallments: Number(formValues.maxAmountInstallments),
        stock: Number(formValues.stock),
        costPrice: Number(formValues.costPrice),
        minimumStock: Number(formValues.minimumStock),
        inactive: formValues.inactive,
        order: formValues.order,

        // Tenancy
        idTenant,

        // Auditoria
        createdAt: formValues.id ? (formValues.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (formValues.id && formValues.createdBy) ? formValues.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o React.
 */
export const serviceFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
